'use client'

import type { TelemetryEventPayload } from '@/lib/telemetry/ingest'

/**
 * Navegador marcado como "do admin": o /api/telemetry respondeu `skipped: 'admin'`
 * uma vez (conta master logada). A partir daí as visitas ANÔNIMAS desse mesmo
 * navegador (antes do login, depois do logout) também não contam — antes elas
 * apareciam como "Visitante" no painel. Para voltar a medir: limpar o
 * localStorage do site.
 */
const ADMIN_DEVICE_KEY = 'cm_telemetry_admin_device'

function isAdminDevice(): boolean {
  try {
    return localStorage.getItem(ADMIN_DEVICE_KEY) === '1'
  } catch {
    return false
  }
}

function markAdminDevice(): void {
  try {
    localStorage.setItem(ADMIN_DEVICE_KEY, '1')
  } catch {
    // ignore
  }
}

/** Envia eventos para /api/telemetry (fire-and-forget). */
export function sendTelemetryEvents(events: TelemetryEventPayload[]): void {
  if (events.length === 0) return
  // Automação/headless (Puppeteer, Playwright, Selenium) se declara via
  // navigator.webdriver mesmo com User-Agent de Chrome normal — o filtro de UA
  // do servidor não pega e cada robô vira um "visitante direto".
  if (typeof navigator !== 'undefined' && navigator.webdriver) return
  if (isAdminDevice()) return

  void fetch('/api/telemetry', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ events }),
    keepalive: true,
  })
    .then(async (res) => {
      if (!res.ok) return
      const body = (await res.json().catch(() => null)) as { skipped?: string } | null
      if (body?.skipped === 'admin') markAdminDevice()
    })
    .catch(() => {})
}
